import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { AppHeader } from '@/components/generals/app-header'
import { SiteFooter } from '@/components/generals/site-footer'
import { SiteHeader } from '@/components/generals/site-header'

// marketing: public pages with the site header and footer
// app: signed-in studio pages with the studio navigation
// bare: no chrome at all, for sign-in pages and the designer
export const Layout: FC<LayoutProps> = ({ children, variant = 'marketing', user = null }): ReactNode => {
    if (variant === 'bare') {
        return (
            <div className='flex min-h-screen flex-col'>
                <main id='main' className='flex flex-1 flex-col'>
                    {children}
                </main>
            </div>
        )
    }

    if (variant === 'app') {
        return (
            <div className='flex min-h-screen flex-col bg-background'>
                <AppHeader user={user} />
                <main id='main' className='flex flex-1 flex-col'>
                    {children}
                </main>
            </div>
        )
    }

    return (
        <div className='flex min-h-screen flex-col'>
            <SiteHeader />
            <main id='main' className='flex-1'>
                {children}
            </main>
            <SiteFooter />
        </div>
    )
}
